import { useMemo } from "react";

import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { Modal } from "@/Common/Components/Modals/Modal";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";

interface IMarkTestPatientPopupProps {
    PatientId: string;
}

function MarkTestPatientPopup(props: Readonly<IMarkTestPatientPopupProps>): JSX.Element {
    let patientModel = useMemo(() => patientStore.PatientModels[props.PatientId], [props.PatientId]);

    return (
        <Modal
            id="markTestpatientPopup"
            title={cacheStore.GetString("TestPatientPopupTitle")}
            onClose={() => sessionStore.dispatch(LocalPatientOperations.Profile.MarkTestPatientCancelClick)}
            draggable
            showOverlay={true}
            cssClass="memo"
            footer={(
                <div className="flex-display flex-end">
                    <ButtonGroup>
                        <ButtonControl
                            label={cacheStore.GetString("CancelLabel")}
                            data-action="cancel"
                            variant="neutral"
                            onClick={() => sessionStore.dispatch(LocalPatientOperations.Profile.MarkTestPatientCancelClick)}
                        />
                        <ButtonControl
                            label={cacheStore.GetString("ContinueLabel")}
                            data-action="save"
                            variant="brand"
                            onClick={() => sessionStore.dispatch(LocalPatientOperations.Profile.MarkTestPatientSaveClick)}
                        />
                    </ButtonGroup>
                </div>
            )}
        >
            <div>
                {!patientModel.PatientResponse.IsTest && (
                    <div>
                        {cacheStore.GetString("MarkTestPatientMessage")}
                    </div>
                )}
                {patientModel.PatientResponse.IsTest && (
                    <div>
                        {cacheStore.GetString("UnMarkTestPatientMessage")}
                    </div>
                )}
            </div>
        </Modal>
    );
}

export { MarkTestPatientPopup };
